import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { RegistrationContext } from '../../context/registration';
import { campaignStory } from '../../services/start-campaign';

import { fetchCampaignContext } from '~/services/registration';

import { TextInput } from '~/shared/components/form/Inputs';
import { ProgressBar } from './ProgressBar';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Label,
} from 'reactstrap';
import { Loading } from '../../shared/components/Loading';
import TipTapEditor from '~/shared/components/tiptap/TipTapEditor';

export const Story = ({}: any) => {
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [goal, setGoal] = useState(0);
    const [showTherm, setShowTherm] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        control,
        reset,
        setValue,
        getValues,
        formState: { errors, isSubmitting, isValid },
    } = useForm({
        basics: '',
        who: '',
        stuggle: '',
        needs: '',
        hope: '',
        help: '',
        summary: '',
        hospital_name: '',
        hospital_url: '',
        hide_hospital: false,
    });

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (campaignRequest) {
            setGoal(campaignRequest.campaign?.goal);
            setShowTherm(campaignRequest.campaign?.show_goal_bar);
            setLoading(false);
        } else {
            getCampaign();
        }
    }, [campaignRequest]);

    const getCampaign = async () => {
        const resp = await fetchCampaignContext();
        console.log('resp: ', resp);

        registrationDispatch({
            type: 'set_registration',
            payload: resp,
        });
    };

    const onSubmit = async (data) => {
        try {
            const title = data.summary;
            console.log('title: ', title);
            delete data.summary;
            const parts = Object.values(data);
            console.log('parts: ', parts);
            const story = parts.join('');
            const payload = {
                title,
                story,
            };
            const resp = await campaignStory(payload);
            history.push('/start-campaign/photo');
        } catch (e) {
            console.log('e: ', e);
        }
    };

    if (loading) {
        return <Loading />;
    }

    const disableNext = !goal;

    return (
        <Container>
            <ProgressBar selectedStep='story' />
            <Row className='justify-content-center py-5'>
                <Col md='8'>
                    <div className='text-center'>
                        <h3>Tell your story</h3>
                    </div>

                    <Card
                        className='box-shadow my-5'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <CardBody className='p-5'>
                            <Row className='justify-content-between'>
                                <Col md='6'>
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <FormGroup>
                                            <Label>
                                                The basics: who are you, and
                                                what is your diagnosis? How long
                                                have you been living with this
                                                diagnosis?
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='basics'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                Who are you outside of your
                                                diagnosis? What are some things
                                                you like or dislike, and some
                                                quirky or interesting facts
                                                about you? What do other people
                                                notice and love about you?
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='who'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                What are five or fewer things
                                                that you struggle with because
                                                of your diagnosis? Choose some
                                                things that anyone can relate
                                                to.
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='struggle'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                What are you fundraising for?
                                                Give some insights on the price
                                                tag associated with these needs.
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='needs'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                How do you hope your life will
                                                change for the better because of
                                                this fundraising campaign or the
                                                medical and related needs it
                                                will help you meet? Include
                                                activities you want to be able
                                                to enjoy, things you want to
                                                achieve, how you can give back
                                                to your community, whether you
                                                plan to return to work, and how
                                                you will be able to spend more
                                                quality time with family and
                                                friends.
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='hope'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                Tell people how they can help.
                                            </Label>
                                            <Controller
                                                control={control}
                                                name='help'
                                                rules={{ required: true }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        onBlur,
                                                    },
                                                }) => {
                                                    return (
                                                        <TipTapEditor
                                                            initialValue={value}
                                                            onChange={onChange}
                                                        />
                                                    );
                                                }}
                                            />
                                        </FormGroup>
                                        <TextInput
                                            name='summary'
                                            label='The final touch! How would you summarize your reason for fundraising in a single sentence? Think of this as a headline for your story.'
                                            control={control}
                                            errors={errors?.summary?.message}
                                        />
                                        <div className='text-center'>
                                            <Button
                                                color='primary'
                                                type='submit'
                                                disabled={
                                                    isSubmitting || !isValid
                                                }
                                            >
                                                {isSubmitting
                                                    ? `Saving...`
                                                    : `Next`}
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                                <Col md='4'>
                                    <Card className='bg-lightblue'>
                                        <CardBody>
                                            <h3>Writing Your Campaign Story</h3>
                                            Writing about yourself to ask for
                                            help is hard! Since we understand
                                            the difficulties involved, we
                                            created this guide to help you think
                                            it through. Let’s start with a few
                                            key things to remember. First, keep
                                            your story simple. Supporters don’t
                                            need a lot of medical or scientific
                                            details. Just help them understand
                                            why they should care and how they
                                            can help. Second, focus on your
                                            goal: how will fundraising make your
                                            life better? Third, we know that you
                                            are defined by far more than your
                                            diagnosis. Let supporters see that,
                                            too.
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
